<template>
  <div class="flow-list">
    <Card v-if="status==='list'">
      <div class="card-wrapper">
        <p class="flow-title">{{flowTitle}}</p>
        <div class="operate">
          <RadioGroup
            v-model="flowStatus"
            type="button"
            @on-change="flowStatusChange"
          >
            <Radio :label="1">待办</Radio>
            <Radio :label="2">进行中</Radio>
            <Radio :label="3">完成</Radio>
          </RadioGroup>
          <Button
            type="primary"
            style="margin-left:16px;"
            @click="newFlow"
            v-if="canNewFlow"
          >发起新流程</Button>
        </div>
        <div class="list-wrapper">
          <div
            class="flow-item"
            v-for="flowItem in flowList"
            v-if="flowList.length>0"
          >
            <div style="line-height:48px;display:inline-block;min-width: 350px;">{{flowItem.WorkflowTitle}}</div>
            <div class="flow-info">
              <span>创建人</span>
              <div style="margin-top:5px;">
                {{flowItem.CreatorRealName}}
              </div>
            </div>
            <div class="flow-info">
              <span>创建时间</span>
              <div style="margin-top:5px;">
                {{flowItem.CreatedTime | filterTime}}
              </div>
            </div>
            <div class="operate-btn">
              <a
                href="javascript:void(0)"
                @click="flowDetailPage(flowItem)"
              >详情</a>
            </div>
          </div>
          <div
            style="text-align:center"
            v-if="flowList.length===0"
          >
            暂无数据
          </div>
        </div>
        <div style="float:right;margin-top:12px;">
          <Page
            :total="flowDataTotal"
            show-elevator
            show-total
            :page-size="6"
            :current="currentPage"
            @on-change="pageChange"
          ></Page>
        </div>
        <div class="clear"></div>
      </div>
    </Card>
    <div v-if="status==='detail'">
      <flowDetail
        @back="back"
        :flowItemDetail="flowItemDetail"
        :flowType="flowType"
        ref="test"
      ></flowDetail>
    </div>
    <!-- 流程信息填写 -->
    <Modal
      v-model="flowInfoVisible"
      title="流程信息"
      class="flow-modal"
      width="800"
      :mask-closable="false"
    >
      <Form
        :label-width="80"
        inline
      >
        <FormItem
          label="流程名称"
          required
        >
          <Input
            v-model="workflowTitle"
            style="width: 600px;"
            readonly
          ></Input>
        </FormItem>
        <FormItem
          label="时间"
          required
        >
          <DatePicker
            type="date"
            style="width: 120px"
            v-model="flowInfo.time"
          ></DatePicker>
        </FormItem>
        <FormItem
          label="地区"
          required
          :label-width="60"
        >
          <Select
            v-model="flowInfo.area"
            style="width: 120px;"
            @on-change="getArea"
            :disabled="flowType==='ZJQR'||flowType==='ZXQR'"
          >
            <Option
              v-for="depart in areaArr"
              :key="depart.id"
              :value="depart.name"
            >{{depart.name}}</Option>
          </Select>
        </FormItem>
        <FormItem
          label="分子公司"
          required
        >
          <Select
            v-model="flowInfo.company"
            style="width: 200px;margin-right:5px;"
            :title="flowInfo.company"
          >
            <Option
              v-for="company in childCompanies"
              :key="company.id"
              :value="company.cName"
            >{{company.cName}}</Option>
          </Select>
        </FormItem>
        <FormItem
          label="提成分类"
          required
          v-if="flowType.indexOf('QR')!==-1"
        >
          <Select
            v-model="flowInfo.flowLine"
            style="width: 120px;"
          >
            <Option value="线下">线下</Option>
            <Option value="线上">线上</Option>
            <Option value="线上线下">线上线下</Option>
          </Select>
        </FormItem>
        <FormItem
          label="备注"
          :label-width="60"
        >
          <Input v-model="flowInfo.opinion" style="width:250px;"></Input>
        </FormItem>
      </Form>
      <div class="extra-info">
        <div v-if="flowType==='GZ'">
          <commissionRuleExtra :flowDetail="flowInfo" flowPosition="list"></commissionRuleExtra>
        </div>
        <div v-if="flowType==='FQ'">
          <commissionOldDeclareExtra :flowDetail="flowInfo" flowPosition="list" :flowLine="flowInfo.flowLine"></commissionOldDeclareExtra>
        </div>
        <div v-if="flowType==='QR'">
          <commissionDeclareExtra :flowDetail="flowInfo" flowPosition="list" :flowLine="flowInfo.flowLine"></commissionDeclareExtra>
        </div>
        <div v-if="flowType==='ZJQR'">
          <commissionDeclareZJ :flowDetail="flowInfo" flowPosition="list" :flowLine="flowInfo.flowLine"></commissionDeclareZJ>
        </div>
        <div v-if="flowType==='ZXQR'">
          <commissionDeclareZX :flowDetail="flowInfo" flowPosition="list" :flowLine="flowInfo.flowLine"></commissionDeclareZX>
        </div>
        <div v-if="flowType==='FP'">
          <commissionGrantExtra :flowDetail="flowInfo" flowPosition="list"></commissionGrantExtra>
        </div>
      </div>
      <div slot="footer">
        <Button @click="flowInfoVisible=false">取消</Button>
        <Button
          @click="finishFlowInfo"
          type="primary"
        >确定</Button>
      </div>
    </Modal>
    <!-- 流程人员选择 -->
    <Modal
      v-model="peopleSelectVisible"
      class="flow-modal"
      width="700px"
      title="流程人员选择"
    >
      <flowNext
        :child-msg="flowPeople"
        @toparentevent="handlePeopleSelect"
      ></flowNext>
      <div slot="footer">
        <Button @click="peopleSelectVisible=false">取消</Button>
        <Button
          @click="startFlow"
          type="primary"
        >确定</Button>
      </div>
    </Modal>
    <!-- 流程分支 -->
    <flowBranch
      :visible="branchVisible"
      :branchList="flowBranch"
      @visibleChange="visibleChange"
      @branchChoose="branchChoose"
      :opinionVisible="false"
    ></flowBranch>
  </div>
</template>

<script>
import { getToDoList, startWorkflow, getActivityUsers, getMyWorkItem } from '@/lib/flow'
import { formatDate, guid } from '@/lib/tool'
import FlowDetail from './flowDetail'
import FlowNext from "./flowNext"
import ajax from '@/lib/ajax'
import requestUrls from '@/lib/requestUrls'
import FlowBranch from './flowBranch'
import CommissionRuleExtra from './extraInfo/commissionRuleExtra'
import CommissionDeclareExtra from './extraInfo/commissionDeclareExtra'
import commissionDeclareZJ from './extraInfo/commissionDeclareZJ'
import commissionDeclareZX from './extraInfo/commissionDeclareZX'
import CommissionGrantExtra from './extraInfo/commissionGrantExtra'
import CommissionOldDeclareExtra from './extraInfo/commissionOldDeclareExtra'

export default {
  name: 'flowList',
  components: {
    FlowDetail,
    FlowNext,
    FlowBranch,
    CommissionRuleExtra,
    CommissionDeclareExtra,
    commissionDeclareZJ,
    CommissionGrantExtra,
    CommissionOldDeclareExtra,
    commissionDeclareZX
  },
  props: {
    flowTitle: {
      type: String,
      default: '流程列表',
    },
    flowType: {
      type: String,
      default: '',
      required: true
    },
    canNewFlow: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      flowList: [],
      flowStatus: 1,
      flowDataTotal: 0,
      currentPage: 1,
      status: 'list',
      flowItemDetail: '',
      peopleSelectVisible: false,
      flowInfoVisible: false,
      areaArr: [],
      flowInfo: {
        title: '',
        area: '',
        company: '',
        time: '',
        flowLine: '',
        opinion: ''
      },
      childCompanies: [],
      flowPeople: {},
      flowBranch: [],
      selectedPeople: '',
      userPhone: '',
      branchVisible: false,
      newFlowId: ''
    }
  },
  async created() {
    if (!this.$store.state.session.user) {
      await this.$store.dispatch({
        type: 'session/init'
      })
    }
    this.userPhone = this.$store.state.session.user.phoneNumber

    this.statusGetData(this.flowStatus, 1)

    let rep = await ajax.get(requestUrls.CLDistrict.GetList)
    this.areaArr = []
    if (rep.data.success && rep.data.result.items.length > 0) {
      this.areaArr = rep.data.result.items
    }
    // 获取分子公司
    let childRep = await ajax.get(requestUrls.bankAccount.getAll)
    // 重复过滤
    let hadPut = []
    this.childCompanies = []
    childRep.data.result.items.forEach(item => {
      if (hadPut.indexOf(item.cName) === -1) {
        hadPut.push(item.cName)
        this.childCompanies.push(item)
      }
    })
  },
  computed: {
    workflowTitle() {
      const area = this.flowInfo.area ? this.flowInfo.area : '地区'
      const time = this.flowInfo.time ? formatDate(this.flowInfo.time, 'miniCN') : '时间'
      const flowLine = this.flowInfo.flowLine ? this.flowInfo.flowLine : '类型'
      if (this.flowType.indexOf('QR')!==-1) {
        return `${area}-${time}-${flowLine}-${this.newFlowId.substr(0, 6)}`
      }
      return `${area}-${time}-${this.newFlowId.substr(0, 6)}`
    }
  },
  methods: {
    async getToDoListData(page = 1) {
      this.currentPage = page
      this.flowList = []
      // 获取代办数据
      try {
        let flowType = this.flowType.indexOf('QR')!==-1 ? 'QR' : this.flowType
        let rep = await getToDoList(this.userPhone, { page: page, size: 6, whereStr: `AppId='${flowType}'` })
        this.flowList = rep.rows
        this.flowDataTotal = rep.total
        this.$emit('dataFilter',this.flowList)
      } catch (err) {
        console.error(err)
        this.flowList = []
      }
    },
    async getMyWorkItemData(page = 1, isHistory = 0) {
      this.currentPage = page
      this.flowList = []
      // 获取个人项目
      try {
        let flowType = this.flowType.indexOf('QR')!==-1 ? 'QR' : this.flowType
        let rep = await getMyWorkItem(this.userPhone, { page: page, size: 6, whereStr: `AppId='${flowType}'`, isHistory: isHistory })
        this.flowList = rep.rows
        this.flowDataTotal = rep.total
        this.$emit('dataFilter',this.flowList)
      } catch (err) {
        console.error(err)
        this.flowList = []
      }
    },
    statusGetData(status, page) {
      if (status === 1) {
        this.getToDoListData(page)
      }
      if (status === 2) {
        this.getMyWorkItemData(page, 0)
      }
      if (status === 3) {
        this.getMyWorkItemData(page, 1)
      }
    },
    flowDetailPage(flowItem) {
      this.flowItemDetail = flowItem
      this.status = 'detail'
    },
    newFlow() {
      if (this.flowType === '') {
        this.$Message.error('无流程类型')
        return
      }

      // let date = formatDate()
      // this.flowInfo.title = `${this.flowTitle}-${date.split(' ')[0]}`

      // 创建wiid
      this.newFlowId = guid()

      this.flowInfoVisible = true
      // 发起流程
    },
    async getArea(district) {
      let rep = await ajax.get(requestUrls.bankAccount.getAll, {
        params: {
          filter: `district == "${district}"`
        }
      })
      this.flowInfo.company = ''
      // 重复过滤
      let hadPut = []
      this.childCompanies = []
      rep.data.result.items.forEach(item => {
        if (hadPut.indexOf(item.cName) === -1) {
          hadPut.push(item.cName)
          this.childCompanies.push(item)
        }
      })
    },
    async finishFlowInfo() {
      this.flowInfo.title = this.workflowTitle
      if (this.flowInfo.title === '' || this.flowInfo.area === '' || this.flowInfo.company === '' || this.flowInfo.time === '') {
        this.$Message.info('请填写完流程基本信息')
        return
      }
      if (this.flowType.indexOf('QR') !== -1 && this.flowInfo.flowLine === '') {
        this.$Message.info('请填写完流程基本信息')
        return
      }
      // 获取流程人员
      let flowType  = this.flowType.indexOf('QR') !== -1 ? 'QR' : this.flowType
      this.$Spin.show()
      try {
        let rep = await getActivityUsers({ appId: flowType, userPhone: this.userPhone })
        this.$Spin.hide()
        this.flowInfoVisible = false
        this.flowBranch = rep
        this.branchVisible = true
      } catch (err) {
        this.$Spin.hide()
        console.error(err)
        this.$Message.error('获取流程人员失败')
      }
    },
    branchChoose(val) {
      this.branchVisible = false
      this.flowPeople = val
      this.peopleSelectVisible = true
    },
    handlePeopleSelect(selectedPeople) {
      this.selectedPeople = selectedPeople
    },
    async startFlow() {
      if (this.selectedPeople === '') {
        this.$Message.error('请先选择流程人员')
        return
      }
      let flowType = this.flowType.indexOf('QR')!==-1 ? 'QR' : this.flowType
      let thisUser = {
        appId: flowType,
        userPhone: this.userPhone,
        wiid: guid(), // 生成一个guid
        flowTitle: this.flowInfo.title,
        businessKey: JSON.stringify(this.flowInfo),
        opinion: this.flowInfo.opinion
      }
      let nextUser = {
        nextActivityCode: this.flowPeople.NextActivityCode,
        userId: this.selectedPeople.userId
      }
      this.$Spin.show()
      try {
        let rep = await startWorkflow(thisUser, nextUser)
        this.$Spin.hide()
        this.$Message.success('流程发起成功')
        this.peopleSelectVisible = false
        // 刷新当前列表
        this.statusGetData(this.flowStatus, 1)
      } catch (err) {
        console.error(err)
        this.$Spin.hide()
        this.$Message.error('发起流程失败')
      }
    },
    flowStatusChange(flowStatus) {
      this.statusGetData(flowStatus, 1)
    },
    back() {
      this.status = 'list'
      // 刷新当前列表数据
      this.statusGetData(this.flowStatus, 1)
    },
    visibleChange(val) {
      this.branchVisible = val
    },
    pageChange(page) {
      this.statusGetData(this.flowStatus, page)
    },
  },
  watch: {
    flowType(val) {
      switch (val) {
        case 'FQ':
          this.flowInfo.flowLine = '线下'
          break
        case 'ZJQR':
          this.flowInfo.area = '湛江'
          this.getArea('湛江')
          break
        case 'ZXQR':
          this.flowInfo.area = '咨询事业部'
          this.getArea('咨询事业部')
          break
      }
    }
  },
  filters: {
    filterTime(val) {
      if (!val) {
        return ''
      }
      let time = parseInt(val.slice(6, 19))
      time = formatDate(time).split(' ')[0]
      return time
    }
  }
}
</script>

<style lang="less">
.flow-list {
  .card-wrapper {
    position: relative;
    padding: 0 16px;
    .flow-title {
      padding: 12px 0 24px 0;
      line-height: 32px;
      font-size: 16px;
      border-bottom: 1px solid #ddd;
    }
    .operate {
      position: absolute;
      right: 16px;
      top: 12px;
    }
    .clear {
      clear: both;
    }
    .list-wrapper {
      position: relative;
      margin-top: 16px;
      .flow-item {
        height: 80px;
        padding: 16px 0;
        margin: 0 16px;
        border-bottom: 1px solid #ddd;
      }
      .flow-info {
        display: inline-block;
        margin-top: 3px;
        vertical-align: top;
        margin-left: 40px;
        color: rgba(0, 0, 0, 0.45);
      }
      .operate-btn {
        display: inline-block;
        position: absolute;
        height: 48px;
        right: 16px;
        line-height: 48px;
      }
    }
  }
}
.flow-modal {
  .ivu-modal {
    top: 20px;
  }
}
</style>
